var render = function render(){
  var _vm$contract$contract, _vm$contract, _vm$contract$contract2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "fullscreen": _vm.$vuetify.breakpoint.xs || _vm.$vuetify.breakpoint.sm,
      "max-width": _vm.$vuetify.breakpoint.xs || _vm.$vuetify.breakpoint.sm ? null : '900px',
      "scrollable": ""
    },
    model: {
      value: _vm.dialogVisible,
      callback: function ($$v) {
        _vm.dialogVisible = $$v;
      },
      expression: "dialogVisible"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "dialog-title"
  }, [_vm._v(_vm._s(_vm.dialogTitle))])]), _c('div', {
    staticClass: "pa-0",
    staticStyle: {
      "position": "relative",
      "flex": "1",
      "overflow-y": "auto"
    }
  }, [!_vm.contract ? _c('div', {
    staticClass: "pa-4 text-center"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("digitalContracts.contractNotFound")))])]) : (_vm$contract$contract = _vm.contract.contract_file) !== null && _vm$contract$contract !== void 0 && _vm$contract$contract.has_file ? _c('div', {
    staticClass: "pdf-container pdf-container-height",
    staticStyle: {
      "border-top": "1px solid #e0e0e0",
      "border-bottom": "1px solid #e0e0e0",
      "overflow-y": "auto"
    }
  }, [_vm.totalPages === 0 ? _c('div', {
    staticClass: "pdf-loading"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }), _c('p', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.$t("digitalContracts.loadingDocument")))])], 1) : _vm._e(), _c('div', {
    staticClass: "pdf-pages-all"
  }, _vm._l(_vm.totalPages, function (pageNum) {
    return _c('canvas', {
      key: pageNum,
      ref: `pdfCanvas${pageNum}`,
      refInFor: true,
      staticClass: "pdf-page",
      staticStyle: {
        "margin-bottom": "20px"
      },
      attrs: {
        "data-page": pageNum
      }
    });
  }), 0)]) : _vm._e(), _vm.showSignatureWidget ? _c('div', {
    staticClass: "signature-overlay",
    on: {
      "click": _vm.onOverlayClick
    }
  }, [_c('div', {
    staticClass: "signature-modal",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "signature-header"
  }, [_c('h3', {
    staticClass: "signature-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("digitalContracts.electronicSignature")) + " ")]), _c('v-btn', {
    staticClass: "signature-close",
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.cancelSignature
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('p', {
    staticClass: "signature-description"
  }, [_vm._v(" " + _vm._s(_vm.$t("digitalContracts.signatureInstructions")) + " ")]), _c('div', {
    staticClass: "signature-container"
  }, [_c('canvas', {
    ref: "signatureCanvas",
    staticClass: "signature-canvas",
    attrs: {
      "width": "600",
      "height": "200"
    },
    on: {
      "mousedown": _vm.startSigning,
      "mousemove": _vm.continueSigning,
      "mouseup": _vm.stopSigning,
      "touchstart": _vm.startSigning,
      "touchmove": _vm.continueSigning,
      "touchend": _vm.stopSigning
    }
  }), _c('div', {
    staticClass: "signature-actions"
  }, [_c('v-btn', {
    staticClass: "mr-3",
    attrs: {
      "outlined": "",
      "color": "grey",
      "disabled": _vm.isSubmittingSignature
    },
    on: {
      "click": _vm.clearSignature
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-delete")]), _vm._v(" " + _vm._s(_vm.$t("digitalContracts.clearSignature")) + " ")], 1), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.hasSignature || _vm.isSubmittingSignature,
      "loading": _vm.isSubmittingSignature
    },
    on: {
      "click": _vm.confirmSignature
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-check")]), _vm._v(" " + _vm._s(_vm.$t("digitalContracts.confirmSignature")) + " ")], 1)], 1)])])]) : _vm._e(), _vm.contract && _vm.contract.user_action === 'accept' && !_vm.hasScrolledToEnd ? _c('div', {
    staticClass: "pa-4 pb-2"
  }, [_c('div', {
    staticClass: "text-caption text--secondary"
  }, [_vm._v(" " + _vm._s(_vm.$t("digitalContracts.scrollToContinue")) + " ")])]) : _vm._e()]), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [(_vm$contract = _vm.contract) !== null && _vm$contract !== void 0 && (_vm$contract$contract2 = _vm$contract.contract_file) !== null && _vm$contract$contract2 !== void 0 && _vm$contract$contract2.url ? _c('v-btn', {
    attrs: {
      "icon": "",
      "color": "primary",
      "title": _vm.$t('digitalContracts.download')
    },
    on: {
      "click": _vm.downloadContract
    }
  }, [_c('IconCustom', {
    attrs: {
      "name": "icn20_download_2"
    }
  })], 1) : _vm._e(), _c('v-spacer'), _vm.contract && _vm.contract.user_action === 'sign' ? [!_vm.showSignatureWidget ? _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showSignatureWidget = true;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("digitalContracts.sign")) + " ")]) : _vm._e()] : _vm.contract && _vm.contract.user_action === 'accept' ? [_c('v-btn', {
    attrs: {
      "color": "grey",
      "text": "",
      "disabled": !_vm.hasScrolledToEnd || _vm.isSubmittingAction,
      "loading": _vm.isSubmittingAction && _vm.lastAction === 'declined'
    },
    on: {
      "click": _vm.showDeclineConfirmDialog
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("digitalContracts.decline")) + " ")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.hasScrolledToEnd || _vm.isSubmittingAction,
      "loading": _vm.isSubmittingAction && _vm.lastAction === 'accepted'
    },
    on: {
      "click": _vm.handleAcceptedAction
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("digitalContracts.accept")) + " ")])] : _vm.contract && _vm.contract.user_action === 'read' ? [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.isSubmittingAction,
      "loading": _vm.isSubmittingAction && _vm.lastAction === 'read'
    },
    on: {
      "click": _vm.handleReadAction
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("digitalContracts.readConfirm")) + " ")])] : _vm._e()], 2)], 1)], 1), _vm.showDeclineConfirm ? _c('ConfirmDialog', {
    attrs: {
      "show-dialog": _vm.showDeclineConfirm,
      "text": _vm.$t('digitalContracts.declineConfirmText')
    },
    on: {
      "closeConfirmDialog": _vm.onDeclineConfirmClose
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }